module.exports = __webpack_public_path__ + "static/media/scanner-keyboard.0793450b.svg";